import { useField, Form, Formik, FieldProps } from "formik";
import { firebase } from "../../lib/firebase";
import "firebase/storage";
import CustomUploadButton from "react-firebase-file-uploader/lib/CustomUploadButton";
import { Fragment, useState } from "react";
import { Control, Help } from "react-bulma-components/lib/components/form";
import { Button } from "react-bulma-components";
import { COLORS } from "../../constants";
import { useAuth } from "../../lib/use-auth";

const UploadInput = ({
  label,
  name,
  helpText,
  accept,
  storageRef,
  uploadURL,
  setUploadURL,
  preview = true,
  ...props
}) => {
  const { user } = useAuth();
  const [previewUrl, setPreviewUrl] = useState(null);
  const [field, meta, helpers] = useField(name);

  if (!user) {
    return <p>Cannot accept uploads from anonymouse users.</p>;
  }
  return (
    <Fragment>
      <Control>
        <CustomUploadButton
          accept={accept}
          className="button is-primary is-outlined"
          randomizeFilename
          multiple={field.multiple}
          storageRef={firebase.storage().ref(`${storageRef}`)}
          onUploadSuccess={async (_, task) => {
            const refUrl = await task.snapshot.ref.getDownloadURL();
            helpers.setValue(task.snapshot.ref.fullPath);
            setUploadURL && setUploadURL(refUrl);
            preview && setPreviewUrl(refUrl);
          }}
        >
          {props.children}
        </CustomUploadButton>
        {preview && previewUrl && (
          <Fragment>
            <Button
              className="button is-text"
              onClick={() => {
                helpers.setValue(null);
                setUploadURL && setUploadURL(null);
                setPreviewUrl(null);
              }}
            >
              Remove
            </Button>
            <br />
            <a target="_blank" href={preview && previewUrl}>{previewUrl}</a>
          </Fragment>
        )}
      </Control>
      <Help color={COLORS.DARK}>{helpText}</Help>
      {meta.error && meta.touched ? (
        <Help color={COLORS.DANGER}>{meta.error}</Help>
      ) : null}
    </Fragment>
  );
};

export default UploadInput;
